/** Pfade der Rechtsseiten (serverseitig gerendert) in der Sprache der Oberfläche. */
export function legalLinks(language: string) {
  const en = language.startsWith('en');
  return {
    imprint: en ? '/en/imprint' : '/impressum',
    privacy: en ? '/en/privacy' : '/datenschutz',
    terms: en ? '/en/terms' : '/agb',
  };
}
